// components
import { Button } from "@mui/material";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import StatusPage from "../StatusPage";
// icons
import TwitterLight from "./../../assets/images/icons_light/twitter.svg";
import DiscordLight from "./../../assets/images/icons_light/discord.svg";
import TelegramLight from "./../../assets/images/icons_light/telegram.svg";
import MediumLight from "./../../assets/images/icons_light/medium.svg";

const SOCIAL_LINKS = [
  { name: "Twitter", href: "https://twitter.com/koindx", icon: TwitterLight },
  { name: "Discord", href: "https://discord.gg/Wh49QvYB3X", icon: DiscordLight },
  { name: "Telegram", href: "https://t.me/koindx", icon: TelegramLight },
  { name: "Medium", href: "https://medium.com/@koindx", icon: MediumLight },
];

const Maintenance = () => (
  <StatusPage
    icon={<ConstructionOutlinedIcon />}
    title="Down for maintenance"
    actions={SOCIAL_LINKS.map((link) => (
      <Button
        key={link.name}
        variant="outlined"
        href={link.href}
        title={`KoinDX ${link.name}`}
        startIcon={<img width="18" height="18" alt="" src={link.icon} />}
      >
        {link.name}
      </Button>
    ))}
  >
    KoinDX will be back shortly. Follow the channels below for updates.
  </StatusPage>
);

export default Maintenance;
